import { render, staticRenderFns } from "./AccountDetailPage.vue?vue&type=template&id=196640ae&scoped=true"
import script from "./AccountDetailPage.vue?vue&type=script&lang=js"
export * from "./AccountDetailPage.vue?vue&type=script&lang=js"
import style0 from "./AccountDetailPage.vue?vue&type=style&index=0&id=196640ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196640ae",
  null
  
)

export default component.exports